// filepath: apps/web/src/features/admin/webhooks/PendingReviewBanner.tsx
//
// FR-UI-ADM-6 AC-9 -- pending-promotion-review banner for the
// webhook endpoint editor. Mirrors
// apps/web/src/features/admin/PendingReviewBanner.tsx but
// scoped to def_type=webhook_endpoint.

import React from "react";
import { useTranslation } from "@/i18n/useTranslation";

interface PendingReviewBannerProps {
  pendingCount: number | null;
  onOpenPromotion: () => void;
}

export function PendingReviewBanner({
  pendingCount,
  onOpenPromotion,
}: PendingReviewBannerProps): React.ReactElement | null {
  const { t } = useTranslation();
  if (pendingCount === null || pendingCount <= 0) return null;
  return (
    <div
      className="rounded border border-yellow-300 bg-yellow-50 px-3 py-2 text-sm text-yellow-900"
      role="status"
      data-testid="pending-review-banner"
    >
      <span>
        {t("admin.webhooks.banner.pending_review")} ({pendingCount})
      </span>
      <button
        type="button"
        className="ml-3 rounded border border-yellow-400 px-2 py-1 text-xs font-medium hover:bg-yellow-100"
        onClick={onOpenPromotion}
        data-testid="pending-review-open"
      >
        {t("admin.webhooks.banner.open_review")}
      </button>
    </div>
  );
}
